// Sistema de Tema - Prontuário Médico
// Cores baseadas no azul profissional/médico

export const theme = {
  // Cores Primárias (Azul Médico)
  primary: {
    50: "#eff6ff",
    100: "#dbeafe",
    200: "#bfdbfe",
    300: "#93c5fd",
    400: "#60a5fa",
    500: "#3b82f6",
    600: "#2563eb",
    700: "#1d4ed8",
    800: "#1e40af",
    900: "#1e3a8a",
  },

  // Gradientes
  gradients: {
    primary: "linear-gradient(135deg, #2563eb 0%, #1e40af 100%)",
    primaryLight: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
    primaryDark: "linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%)",
    header: "linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%)",
  },

  // Cores de Status
  status: {
    success: {
      bg: "#d1fae5",
      border: "#10b981",
      text: "#064e3b",
      gradient: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    },
    error: {
      bg: "#fee2e2",
      border: "#ef4444",
      text: "#7f1d1d",
      gradient: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
    },
    warning: {
      bg: "#fef3c7",
      border: "#f59e0b",
      text: "#78350f",
      gradient: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
    },
    info: {
      bg: "#dbeafe",
      border: "#3b82f6",
      text: "#1e3a8a",
      gradient: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
    },
  },

  // Cores por Tipo de Atendimento
  tipoAtendimento: {
    ambulatorial: {
      bg: "#dbeafe", // Azul claro
      border: "#3b82f6", // Azul médio
      text: "#1e3a8a", // Azul escuro
    },
    figado: {
      bg: "#d1fae5", // Verde claro
      border: "#10b981", // Verde médio
      text: "#064e3b", // Verde escuro
    },
    rim: {
      bg: "#fce7f3", // Rosa/vinho claro
      border: "#be185d", // Vinho/rosa escuro
      text: "#831843", // Vinho escuro
    },
    pancreas: {
      bg: "#fef3c7", // Amarelo claro
      border: "#f59e0b", // Amarelo/laranja
      text: "#92400e", // Marrom escuro
    },
    // B351 (AI_152) — doador vivo de fígado. Turquesa: perto do verde do fígado
    // (é a mesma linha de cuidado) mas distinguível à distância na lista, que é
    // onde o risco real está — confundir doador com receptor.
    doador_figado: {
      bg: "#ccfbf1", // Turquesa claro
      border: "#14b8a6", // Turquesa médio
      text: "#134e4a", // Turquesa escuro
    },
  },

  // Cores Neutras
  gray: {
    50: "#f9fafb",
    100: "#f3f4f6",
    200: "#e5e7eb",
    300: "#d1d5db",
    400: "#9ca3af",
    500: "#6b7280",
    600: "#4b5563",
    700: "#374151",
    800: "#1f2937",
    900: "#111827",
  },

  // Sombras
  shadows: {
    sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    md: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
    lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
    primary: "0 4px 12px rgba(37, 99, 235, 0.3)",
    primaryHover: "0 8px 20px rgba(37, 99, 235, 0.4)",
  },

  // Bordas
  borderRadius: {
    sm: "6px",
    md: "10px",
    lg: "12px",
    xl: "16px",
    full: "9999px",
  },

  // Transições
  transitions: {
    fast: "all 0.15s ease",
    normal: "all 0.3s ease",
    slow: "all 0.5s ease",
  },

  // Fontes
  fonts: {
    sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    mono: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
  },
};

// Funções auxiliares para facilitar uso
export const getGradient = (type: keyof typeof theme.gradients = "primary") =>
  theme.gradients[type];

export const getShadow = (type: keyof typeof theme.shadows = "md") =>
  theme.shadows[type];

export const getBorderRadius = (type: keyof typeof theme.borderRadius = "md") =>
  theme.borderRadius[type];
